var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",class:_vm.labelClass},[_c('p',{staticClass:"subtitle-1 margin-top-twenty font-weight-bold"},[_c('v-icon',{attrs:{"dark":_vm.regisStatus == 1 || _vm.regisStatus == 3}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }